import { doBetsStore, roundsInfoStore } from '../../store';
import {
  clickedOverBetBlock,
  clickedUnderBetBlock,
  loseOverBetBlock,
  loseUnderBetBlock,
  wonOverBetBlock,
  wonUnderBetBlock,
} from '../../constants/canvasConfig';
import { betBlock } from './betBlockDrawer';
import { getGameCanvasStandards } from '../../helpers/gameCanvasHelper';
import { betTypes } from '../../enums';
import { gameResultStore } from "@pascal/pascal-core";
const underOverBetBlockSize = { w: 150, h: 75 };


export const drawPendingUnderOverBets = () => {
  const { gameResults } = gameResultStore;
  const lustResult = gameResults[6] ? gameResults[6].roundData.resultPoint : 0;
  const { canvas } = getGameCanvasStandards();
  const { underOverBets, presentPoint, concentrationDiff} = roundsInfoStore;
  const {isShowBetBlocks} = doBetsStore;

  const underBetBlockConfigByStatus = [loseUnderBetBlock, wonUnderBetBlock, clickedUnderBetBlock];
  const overBetBlockConfigByStatus = [loseOverBetBlock, wonOverBetBlock, clickedOverBetBlock];

  const underBet = underOverBets[betTypes.under] && {
    ...underOverBets[betTypes.under],
    ...underOverBetBlockSize,
    x: presentPoint.x - 165,
    y: canvas.height - ((lustResult - 5) * 10 - concentrationDiff),
  };

  const overBet = underOverBets[betTypes.over] && {
    ...underOverBets[betTypes.over],
    ...underOverBetBlockSize,
    x: presentPoint.x - 165,
    y: canvas.height - ((lustResult + 12) * 10 - concentrationDiff),
  };

  if(!isShowBetBlocks){
    overBet && betBlock(overBet, overBetBlockConfigByStatus[overBet.status]);
    underBet && betBlock(underBet, underBetBlockConfigByStatus[underBet.status]);
  }
};


